var _rect, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 246,
    viewBox: "0 0 246 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 245.25,
    height: 245.25,
    rx: 122.625,
    stroke: "#AEAEB2",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25404_32728)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 246,
    rx: 123,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.349,
    cy: 88.7477,
    rx: 265.862,
    ry: 267.363,
    transform: "rotate(45 154.349 88.7477)",
    fill: "url(#paint0_radial_25404_32728)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.121,
    cy: 199.123,
    rx: 388.644,
    ry: 141.582,
    transform: "rotate(-59.902 218.121 199.123)",
    fill: "url(#paint1_radial_25404_32728)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 238,
    height: 238,
    rx: 119,
    stroke: "#F2F2F7",
    strokeWidth: 8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.682 95.4563V105.176V118.643C155.682 120.959 155.611 123.264 155.306 125.57C155.357 125.163 155.418 124.757 155.469 124.351C154.971 128.027 153.986 131.623 152.564 135.035C152.716 134.67 152.869 134.304 153.021 133.948C151.589 137.341 149.73 140.53 147.476 143.445C147.709 143.14 147.953 142.825 148.187 142.52C146.003 145.334 143.474 147.863 140.651 150.046C140.955 149.812 141.27 149.569 141.575 149.335C138.995 151.326 136.141 152.971 133.369 154.688C129.946 156.82 126.513 158.943 123.091 161.076C122.237 161.604 121.394 162.132 120.541 162.66H125.152C122.918 161.289 120.673 159.928 118.439 158.557C115.26 156.617 112.081 154.677 108.912 152.738C107.379 151.803 105.886 150.818 104.454 149.731C104.758 149.965 105.073 150.209 105.378 150.442C102.544 148.248 99.9952 145.709 97.8014 142.876C98.035 143.18 98.2788 143.495 98.5124 143.8C96.278 140.905 94.4296 137.747 93.0077 134.385C93.16 134.751 93.3124 135.116 93.4647 135.472C92.0225 132.039 91.0374 128.423 90.5296 124.737C90.5804 125.143 90.6413 125.549 90.6921 125.955C90.1639 121.995 90.3163 117.973 90.3163 113.981C90.3163 109.035 90.3163 104.089 90.3163 99.143C90.3163 97.9141 90.3163 96.6953 90.3163 95.4664C89.1991 96.9391 88.0819 98.4016 86.9647 99.8742C97.6491 97.65 108.11 93.9734 117.545 88.4383C120.186 86.8945 122.725 85.1984 125.162 83.3602C123.629 83.3602 122.085 83.3602 120.551 83.3602C130.037 90.2969 140.976 95.3547 152.33 98.3508C154.544 98.9398 156.789 99.4172 159.033 99.8742C160.242 100.118 161.461 100.057 162.558 99.4172C163.502 98.8586 164.406 97.7719 164.66 96.6852C164.924 95.5172 164.873 94.207 164.203 93.1609C163.583 92.1961 162.629 91.3023 161.471 91.0586C154.9 89.7078 148.491 87.8797 142.296 85.2797C142.662 85.432 143.027 85.5844 143.383 85.7367C136.933 83.0148 130.799 79.582 125.152 75.4484C123.984 74.5953 121.709 74.5648 120.541 75.4484C115.098 79.5617 109.126 82.9133 102.839 85.5641C103.205 85.4117 103.57 85.2594 103.926 85.107C97.6694 87.7375 91.1491 89.6672 84.5171 91.0484C84.1514 91.2008 83.7858 91.3531 83.4304 91.5055C82.9022 91.7898 82.4655 92.1859 82.1507 92.6836C81.5311 93.4859 81.1655 94.4203 81.1655 95.4563V108.131C81.1655 112.438 81.0944 116.754 81.1757 121.07C81.2671 126.108 82.1507 131.216 83.8772 135.949C84.8014 138.478 85.8983 140.956 87.2186 143.302C88.5186 145.608 90.0522 147.751 91.6975 149.813C94.8358 153.753 98.7257 157.125 102.971 159.827C104.312 160.68 105.683 161.492 107.044 162.315C111.441 165.006 115.839 167.688 120.247 170.379C120.338 170.44 120.44 170.501 120.531 170.552C121.892 171.384 123.791 171.395 125.142 170.552C129.042 168.134 132.932 165.707 136.832 163.29C138.579 162.203 140.326 161.116 142.073 160.04C145.607 157.846 148.928 155.297 151.802 152.28C155.184 148.736 158.079 144.633 160.161 140.205C161.308 137.777 162.294 135.269 163.035 132.689C163.766 130.109 164.213 127.489 164.518 124.828C164.782 122.584 164.802 120.349 164.802 118.095C164.802 115.535 164.802 112.976 164.802 110.427C164.802 105.531 164.802 100.646 164.802 95.7508C164.802 95.6594 164.802 95.5578 164.802 95.4664C164.802 94.2984 164.294 93.0594 163.462 92.2367C162.669 91.4445 161.369 90.8453 160.232 90.8961C159.054 90.9469 157.825 91.3328 157.002 92.2367C156.2 93.1102 155.682 94.2172 155.682 95.4563Z",
    fill: "#FFD9DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.857 171.171C124.024 171.171 125.264 170.663 126.086 169.831C126.878 169.038 127.478 167.738 127.427 166.601C127.376 165.423 126.99 164.194 126.086 163.371C125.192 162.548 124.096 162.031 122.857 162.031C121.689 162.031 120.449 162.538 119.627 163.371C118.835 164.163 118.235 165.463 118.286 166.601C118.337 167.779 118.723 169.008 119.627 169.831C120.521 170.653 121.617 171.171 122.857 171.171Z",
    fill: "#FFD9DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.43 103.216V111.838V125.509V128.647C118.43 129.815 118.938 131.054 119.77 131.877C120.563 132.669 121.862 133.268 123 133.217C124.178 133.166 125.407 132.78 126.23 131.877C127.052 130.983 127.57 129.886 127.57 128.647C127.57 125.773 127.57 122.898 127.57 120.024C127.57 115.464 127.57 110.914 127.57 106.354C127.57 105.308 127.57 104.262 127.57 103.216C127.57 102.048 127.062 100.809 126.23 99.986C125.437 99.1938 124.137 98.5946 123 98.6453C121.822 98.6961 120.593 99.0821 119.77 99.986C118.948 100.88 118.43 101.977 118.43 103.216Z",
    fill: "#FFD9DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.43 141.434V142.784C118.43 143.952 118.938 145.191 119.77 146.014C120.187 146.461 120.674 146.776 121.243 146.959C121.791 147.243 122.37 147.375 123 147.355C124.178 147.304 125.407 146.918 126.23 146.014C127.052 145.12 127.57 144.024 127.57 142.784C127.57 142.338 127.57 141.881 127.57 141.434C127.57 140.266 127.062 139.027 126.23 138.204C125.813 137.757 125.326 137.442 124.757 137.259C124.209 136.975 123.63 136.843 123 136.863C121.822 136.914 120.593 137.3 119.77 138.204C118.948 139.098 118.43 140.195 118.43 141.434Z",
    fill: "#FFD9DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_25404_32728",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.6838 -204.75 203.6 -54.9926 153.234 65.7442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F90004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90004",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_25404_32728",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-79.9383 -108.426 297.629 -29.1214 216.492 186.942)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E86B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#E86B4C",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E86B4C",
    stopOpacity: 0.167143
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E86B4C",
    stopOpacity: 0.0911688
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86B4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25404_32728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 246,
    rx: 123,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.038d43ac678cb70a19d96e55eb5554c2.svg";
export { ForwardRef as ReactComponent };